import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import SignInError from "./IncorrectPasswordAlert";
import {
  LOGIN_FORM_COLUMN_MAX_WIDTH_CSS,
  LOGIN_FORM_COLUMN_WIDTH,
  LOGIN_FORM_GAP_CSS,
  LOGIN_FORM_HEADING_FONT_SIZE,
  LOGIN_FORM_HEADING_GAP_CSS,
  LOGIN_FORM_PANEL_GUTTER_CSS,
  LOGIN_FORM_PANEL_WIDTH,
  LOGIN_FORM_SUBTITLE_FONT_SIZE,
  LOGIN_FULL_HEIGHT_CSS,
  LOGIN_FULL_WIDTH_CSS,
  LOGIN_HEADING_MIN_FONT_PX,
  LOGIN_NO_MINIMUM_CSS,
  LOGIN_SCREEN_HEIGHT,
  LOGIN_TEXT_MIN_FONT_PX
} from "./login-constants";
import { getFlooredFontSize } from "./login-layout";
import PasswordFormItem from "./PasswordFormItem";
import SignInButton from "./SignInButton";
import UsernameFormItem from "./UsernameFormItem";

const SignInForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, getFontSize } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={LOGIN_FORM_PANEL_WIDTH}
      height={LOGIN_SCREEN_HEIGHT}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        flexGrow: 1,
        flexShrink: 1,
        width: "auto",
        minWidth: LOGIN_NO_MINIMUM_CSS,
        height: LOGIN_FULL_HEIGHT_CSS,
        minHeight: LOGIN_NO_MINIMUM_CSS,
        paddingLeft: LOGIN_FORM_PANEL_GUTTER_CSS,
        paddingRight: LOGIN_FORM_PANEL_GUTTER_CSS
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={LOGIN_FORM_COLUMN_WIDTH}
        height={0}
        fDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          width: LOGIN_FULL_WIDTH_CSS,
          minWidth: LOGIN_NO_MINIMUM_CSS,
          maxWidth: LOGIN_FORM_COLUMN_MAX_WIDTH_CSS,
          gap: LOGIN_FORM_GAP_CSS
        }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={LOGIN_FORM_COLUMN_WIDTH}
          height={0}
          fDirection="column"
          alignItems="flex-start"
          justifyContent="center"
          color={colors.all.transparent}
          style={{
            width: LOGIN_FULL_WIDTH_CSS,
            minWidth: LOGIN_NO_MINIMUM_CSS,
            gap: LOGIN_FORM_HEADING_GAP_CSS
          }}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={LOGIN_FORM_HEADING_FONT_SIZE}
            text={i18n.get("SIGN_IN")}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              margin: 0,
              textAlign: "left",
              fontSize: getFlooredFontSize(
                getFontSize(LOGIN_FORM_HEADING_FONT_SIZE),
                LOGIN_HEADING_MIN_FONT_PX
              )
            }}
          />
          <Et3Text
            fontFamily={"LIGHT"}
            fontSize={LOGIN_FORM_SUBTITLE_FONT_SIZE}
            text={i18n.get("LOGIN_SUBTITLE")}
            isSpan={false}
            color={colors.all.davysGrey}
            style={{
              margin: 0,
              textAlign: "left",
              fontSize: getFlooredFontSize(
                getFontSize(LOGIN_FORM_SUBTITLE_FONT_SIZE),
                LOGIN_TEXT_MIN_FONT_PX
              )
            }}
          />
        </ET3Div>
        <SignInError />
        <UsernameFormItem />
        <PasswordFormItem />
        <SignInButton />
      </ET3Div>
    </ET3Div>
  );
});
export default SignInForm;
